export const convertTimeFromUSA = (value: string) => {
    const [time, period] = value.split(' ');
    const [hours, minutes] = time.split(':');
    const intHours = Number(hours);
    const formattedHours = period === 'AM' ? hours : intHours + 12;

    return `${formattedHours}:${minutes}`;
};
